// extracted by mini-css-extract-plugin
export default {"layout":"_41070bfece _596cb0e0be f7c94e01c0","h_slide":"_9231393077","category":"_95744dde53 _147c624072 ea87c08aa6"};